module.exports = __webpack_public_path__ + "static/media/bsc-logo.400dc0a0.jpg";